module.exports = __webpack_public_path__ + "img/马修-阿奎诺.5eb163b9.png";